import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RefundedStatusAttributeFilter } from '../../../models/refunded-status-attribute-filter';
import { RefundedStatus } from '../../../../../../models/enums/refunded.enum';

@Component({
  selector: 'jhi-refunded-status-filter',
  templateUrl: './refunded-status-filter.component.html',
  styleUrls: ['./refunded-status-filter.component.scss'],
})
export class RefundedStatusFilterComponent {
  @Input() filter!: RefundedStatusAttributeFilter;
  @Output() filterChange = new EventEmitter<RefundedStatusAttributeFilter>();

  refundedStatus = RefundedStatus;
}
